/* PDI Plancia PRO JS — v51 (Premium Layout Update) */
document.addEventListener('DOMContentLoaded', () => {
  const MIN_LEN_CM = 100;

  const ID_SVC_NONE = "56842280862044";
  const ID_SVC_CHECK = "56842280894812";

  // LOGICA DEI 7 SCAGLIONI DI PREZZO
  function ratePerMeter(m){ 
    if (m <= 3) return 12;
    if (m <= 10) return 10;
    if (m <= 29) return 9;
    if (m <= 59) return 8;
    if (m <= 99) return 7;
    if (m <= 199) return 6;
    return 5;
  }

  function calcPriceTier(lenCm){
    const L = Math.max(MIN_LEN_CM, Math.ceil(lenCm));
    const billedM = L / 100;
    const rate = ratePerMeter(billedM);
    return { L, billedM, rate, total: billedM * rate };
  }

  // LETTURA DEI 7 VARIANT ID DAL DATA-ATTRIBUTE
  function pickVariantId(root, meters){
    if (meters <= 3) return String(root.getAttribute('data-var-1'));
    if (meters <= 10) return String(root.getAttribute('data-var-2'));
    if (meters <= 29) return String(root.getAttribute('data-var-3'));
    if (meters <= 59) return String(root.getAttribute('data-var-4'));
    if (meters <= 99) return String(root.getAttribute('data-var-5'));
    if (meters <= 199) return String(root.getAttribute('data-var-6'));
    return String(root.getAttribute('data-var-7'));
  }

  async function addToCart(payloadItems){
    const res = await fetch('/cart/add.js', {
      method:'POST',
      headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
      body: JSON.stringify({ items: payloadItems })
    });
    if (!res.ok) {
      const err = await res.json();
      throw new Error(err.message || 'Errore Sconosciuto da Shopify');
    }
  }

  function initPro(){
    const root = document.querySelector('[data-pdi-pro]');
    if (!root || root.dataset.pdiInit === '1') return;
    root.dataset.pdiInit = '1';

    const inputLen = root.querySelector('#pdiProLen');
    const inputName = root.querySelector('#pdiProName'); 
    const inputLink = root.querySelector('#pdiProLink');
    
    const cardWT = root.querySelector('#pdiBtnWeTransfer');
    const cardEmail = root.querySelector('#pdiBtnEmail');
    let selectedMethod = null; // 'wt' o 'email'
    
    let hasAutoOpened = false;

    const inputNotes = root.querySelector('#pdiProNotes');
    const checkLegal = root.querySelector('#pdiProLegal');
    
    const priceEl = root.querySelector('#pdiProPrice');
    const lenOutEl = root.querySelector('#pdiProLenOut');
    const billMEl = root.querySelector('#pdiProBillM');
    
    const addBtn = root.querySelector('#pdiProAddBtn');
    const btnTxt = root.querySelector('#pdiProBtnTxt');
    const alertBox = root.querySelector('#pdiLenAlert');

    const sheet = root.querySelector('#pdiProSheet');
    const sheetHeader = root.querySelector('#pdiProSheetHeader');
    
    let sheetMotion=null, sheetUiExpanded, sheetUiHeight=0;
    function animateSheetTransition(expanded){
      const changed=sheetUiExpanded!==undefined&&sheetUiExpanded!==expanded;
      const previousHeight=sheetUiHeight;
      sheetUiExpanded=expanded;
      if(changed)sheetMotion?.cancel();
      requestAnimationFrame(()=>{
        if(!sheet||sheet.classList.contains('is-expanded')!==expanded)return;
        const nextHeight=sheet.offsetHeight;
        if(changed&&previousHeight&&sheet.animate&&!window.matchMedia('(prefers-reduced-motion: reduce)').matches){
          const distance=nextHeight-previousHeight;
          if(Math.abs(distance)>1)sheetMotion=sheet.animate([{transform:'translateY('+distance+'px)'},{transform:'translateY(0)'}],{duration:260,easing:'cubic-bezier(.2,.8,.2,1)'});
        }
        sheetUiHeight=nextHeight;
      });
    }
    function enhanceFields(){
      const isField=node=>node?.matches('input:not([type="file"]):not([type="checkbox"]):not([type="radio"]),textarea,select');
      const filled=node=>node.dataset.uiFilled=String(!!node.value.trim());
      root.addEventListener('input',event=>{if(isField(event.target))filled(event.target);});
      root.addEventListener('change',event=>{if(isField(event.target))filled(event.target);});
      root.addEventListener('focusout',event=>{
        const node=event.target;if(!isField(node)||node.disabled)return;
        filled(node);
        if(node.type==='number')node.setAttribute('aria-invalid',String(!node.validity.valid));
      });
    }
    function syncSheetHeight() {
        if (!sheet || !sheetHeader) return;
        requestAnimationFrame(() => {
          const vv = window.visualViewport;
          const height = vv ? vv.height : window.innerHeight;
          const offset = vv ? vv.offsetTop : 0;
          let top = 12;
          document.querySelectorAll('#pdiDesktopBar, #pdiMobileHeader').forEach(header => {
            const rect = header.getBoundingClientRect();
            if (rect.width && rect.height && rect.bottom > offset && ['fixed','sticky'].includes(getComputedStyle(header).position)) top = Math.max(top, rect.bottom - offset + 12);
          });
          const h = sheetHeader.offsetHeight;
          sheet.style.setProperty('--header-h', h + 'px');
          root.style.setProperty('--pdi-sheet-height', h + 'px');
          sheet.style.setProperty('--pdi-sheet-limit', Math.max(h, height - top) + 'px');
          sheet.parentElement.style.bottom = Math.max(0, window.innerHeight - offset - height) + 'px';
          sheetUiHeight = sheet.offsetHeight;
        });
    }
    function syncSheetAccessibility(){
      if(!sheet)return;
      const expanded=sheet.classList.contains('is-expanded');
      const body=root.querySelector('#pdiProSheetBody');
      if(body){body.inert=!expanded;body.setAttribute('aria-hidden',String(!expanded));}
      sheetHeader?.setAttribute('aria-expanded',String(expanded));
      const hint=root.querySelector('.pdiSheetHint');if(hint)hint.textContent=expanded?'Chiudi riepilogo':'Apri riepilogo';
      syncSheetHeight();animateSheetTransition(expanded);
    }
    function toggleSheet(){if(sheet)sheet.classList.toggle('is-expanded');syncSheetAccessibility();}
    window.addEventListener('resize',syncSheetHeight);
    window.visualViewport?.addEventListener('resize',syncSheetHeight);
    window.visualViewport?.addEventListener('scroll',syncSheetHeight);
    if(window.ResizeObserver&&sheetHeader)new ResizeObserver(syncSheetHeight).observe(sheetHeader);
    sheetHeader?.addEventListener('click',toggleSheet);
    sheetHeader?.addEventListener('keydown',event=>{if(event.key==='Enter'||event.key===' '){event.preventDefault();toggleSheet();}});
    sheet?.addEventListener('keydown',event=>{if(event.key==='Escape'){event.preventDefault();sheet.classList.remove('is-expanded');syncSheetAccessibility();sheetHeader?.focus();}});
    root.querySelector('#pdiReadyReview')?.addEventListener('click',()=>{sheet?.classList.add('is-expanded');syncSheetAccessibility();sheetHeader?.focus();});
    const lenMoreBtns=root.querySelectorAll('#pdiLenMoreBtn, #pdiLenMoreBtn2');
    const lenModal=root.querySelector('#pdiLenModal');
    let modalTrigger=null;
    function closeInfo(){if(!lenModal)return;lenModal.classList.remove('is-on');lenModal.inert=true;lenModal.setAttribute('aria-hidden','true');modalTrigger?.focus();}
    lenMoreBtns.forEach(btn=>btn.addEventListener('click',()=>{if(!lenModal)return;modalTrigger=btn;lenModal.inert=false;lenModal.classList.add('is-on');lenModal.setAttribute('aria-hidden','false');lenModal.querySelector('[data-close-len].pdiModal__close')?.focus();}));
    lenModal?.addEventListener('click',event=>{if(event.target?.hasAttribute('data-close-len'))closeInfo();});
    lenModal?.addEventListener('keydown',event=>{if(event.key==='Escape'){event.preventDefault();event.stopPropagation();closeInfo();}else if(event.key==='Tab'){const nodes=Array.from(lenModal.querySelectorAll('button,a[href],input,textarea,[tabindex="0"]')).filter(n=>n.offsetParent!==null);const first=nodes[0],last=nodes[nodes.length-1];if(event.shiftKey&&document.activeElement===first){event.preventDefault();last?.focus();}else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first?.focus();}}});

    function getService(){
      const r = root.querySelector('input[name="pdi_pro_service"]:checked');
      return r ? r.value : null;
    }

    const allServices = root.querySelectorAll('input[name="pdi_pro_service"]');
    allServices.forEach(chk => {
      chk.addEventListener('click', function(e) {
        if(this.checked) {
          allServices.forEach(other => { if(other !== this) other.checked = false; });
        }
        updatePrice(); syncGating();
      });
    });

    function setPriceWithTax(total) {
      if (priceEl) priceEl.textContent = total.toFixed(2);
      const gross = root.querySelector('[data-pdi-gross-price]');
      if (gross) {
        const cents = Math.round(total * 100);
        const factor = root.dataset.pdiTaxesIncluded === 'true' ? 1 : 1.22;
        gross.textContent = (Math.round(cents * factor) / 100).toLocaleString('it-IT', {minimumFractionDigits: 2, maximumFractionDigits: 2});
      }
    }
    function updatePrice() {
      if(!inputLen || !priceEl || !lenOutEl || !billMEl) return;
      const rawVal = parseFloat(inputLen.value) || 0;
      
      if (rawVal === 0) {
        setPriceWithTax(0); lenOutEl.textContent = "0"; billMEl.textContent = "0";
        if (alertBox) alertBox.style.display = "none";
        syncSheetHeight(); 
        return;
      }

      if (alertBox) {
        if (rawVal > 0 && rawVal < MIN_LEN_CM) alertBox.style.display = "block";
        else alertBox.style.display = "none";
      }

      const { L, billedM, rate, total } = calcPriceTier(rawVal);
      let extra = 0; if (getService() === 'check') extra = 5;
      const finalTotal = total + extra;

      setPriceWithTax(finalTotal);
      lenOutEl.textContent = String(L);
      billMEl.textContent = billedM.toFixed(2);
      
      root.dataset.pdiLen = String(L);
      root.dataset.pdiBillM = String(billedM);

      syncSheetHeight(); 
    }

    if (cardWT) {
      cardWT.addEventListener('click', (e) => {
        if (e.target.closest('.pdiMethodInputCollapse') && selectedMethod === 'wt') return;

        if (selectedMethod === 'wt') {
          selectedMethod = null;
          cardWT.classList.remove('is-active');
          if (cardEmail) cardEmail.classList.remove('is-dimmed');
        } else {
          selectedMethod = 'wt';
          cardWT.classList.add('is-active');
          cardWT.classList.remove('is-dimmed');
          if (cardEmail) {
            cardEmail.classList.remove('is-active');
            cardEmail.classList.add('is-dimmed');
          }
          syncGating();
          if (inputLink && e.target !== inputLink) {
            inputLink.focus();
          }
        }
        syncGating();
      });
    }

    if (cardEmail) {
      cardEmail.addEventListener('click', () => {
        if (selectedMethod === 'email') {
          selectedMethod = null;
          cardEmail.classList.remove('is-active');
          if (cardWT) cardWT.classList.remove('is-dimmed');
        } else {
          selectedMethod = 'email';
          cardEmail.classList.add('is-active');
          cardEmail.classList.remove('is-dimmed');
          if (cardWT) {
            cardWT.classList.remove('is-active');
            cardWT.classList.add('is-dimmed');
          }
          if(inputLink) inputLink.value = '';
        }
        syncGating();
      });
    }

    if (inputLink) {
      inputLink.addEventListener('input', () => {
        if(inputLink.value.length > 0 && selectedMethod !== 'wt') {
           selectedMethod = 'wt';
           cardWT.classList.add('is-active');
           cardWT.classList.remove('is-dimmed');
           if (cardEmail) {
             cardEmail.classList.remove('is-active');
             cardEmail.classList.add('is-dimmed');
           }
        }
        syncGating();
      });
    }

    function syncGating() {
      if(!inputLen || !addBtn || !btnTxt) return;
      
      const len = parseFloat(inputLen.value) || 0;
      const hasLen = len >= MIN_LEN_CM;
      
      const nameVal = inputName ? inputName.value.trim() : '';
      const hasName = nameVal.length > 0;
      
      const linkVal = inputLink ? inputLink.value.trim() : '';
      
      let hasFile = false;
      if (selectedMethod === 'email') {
        hasFile = true;
      } else if (selectedMethod === 'wt') {
        hasFile = linkVal.length > 5;
      }

      if(hasName && hasLen && hasFile && !hasAutoOpened && sheet) {
        sheet.classList.add('is-expanded');
        hasAutoOpened = true;
        syncSheetAccessibility(); 
      }

      const isLegalOk = checkLegal ? checkLegal.checked : false;
      const hasService = getService() !== null;

      const isOk = hasName && hasLen && hasFile && isLegalOk && hasService;
      addBtn.disabled = !isOk;
      const wt=selectedMethod==='wt';
      inputLink?.setAttribute('aria-required',String(wt));
      root.querySelector('#pdiSelectWT')?.setAttribute('aria-pressed',String(wt));
      root.querySelector('#pdiSelectEmail')?.setAttribute('aria-pressed',String(selectedMethod==='email'));
      const collapse=root.querySelector('#pdiWeTransferCollapse');if(collapse){collapse.inert=!wt;collapse.setAttribute('aria-hidden',String(!wt));}
      const nameOut=root.querySelector('#pdiReadyName');if(nameOut)nameOut.textContent=nameVal||'Da inserire';
      const methodOut=root.querySelector('#pdiReadyMethod');if(methodOut)methodOut.textContent=wt?'Link WeTransfer':selectedMethod==='email'?'Email dopo l’acquisto':'Da scegliere';

      if (!hasName) {
        btnTxt.textContent = "⚠️ Inserisci Nome Progetto";
      } else if (!hasLen) {
        btnTxt.textContent = "⚠️ Inserisci la lunghezza (Min. 100 cm)";
      } else if (!selectedMethod) {
        btnTxt.textContent = "⚠️ Scegli WeTransfer o Email";
      } else if (selectedMethod === 'wt' && !hasFile) {
        btnTxt.textContent = "⚠️ Incolla il link WeTransfer";
      } else if (!isLegalOk) {
        btnTxt.textContent = "⚠️ Accetta i diritti (nel cassetto in basso)";
      } else if (!hasService) {
        btnTxt.textContent = "⚠️ Scegli opzione verifica file";
      } else {
        btnTxt.textContent = "AGGIUNGI AL CARRELLO 🛒";
      }
    }

    if (inputName) inputName.addEventListener('input', syncGating);
    if (inputLen) inputLen.addEventListener('input', () => { updatePrice(); syncGating(); });
    if (checkLegal) checkLegal.addEventListener('change', syncGating);

    if (addBtn){
      addBtn.addEventListener('click', async () => {
        if (addBtn.disabled) return;
        btnTxt.textContent = "⏳ Aggiunta al carrello...";
        addBtn.disabled = true;

        try {
          const L = Number(root.dataset.pdiLen || 0); 
          const billedM = Number(root.dataset.pdiBillM || 0); 
          
          const variantId = pickVariantId(root, billedM);
          if (!variantId || variantId === "0" || variantId.includes("INCOLLA")) {
            throw new Error("Variant ID mancanti nei settaggi del codice Liquid");
          }

          const finalLink = (selectedMethod === 'email') ? "DA RICEVERE via email a printdtfitaliagrafica@gmail.com: Il cliente invierà il file rispondendo alla mail di conferma o in separata sede." : (inputLink ? inputLink.value.trim() : '');

          let serviceId = ID_SVC_NONE;
          let serviceName = "Nessuna verifica";
          if (getService() === 'check') { serviceId = ID_SVC_CHECK; serviceName = "Verifica pro"; }

          const propsBase = {
            'Nome Progetto': inputName ? inputName.value.trim() : '',
            'Link File di Stampa': finalLink,
            'Istruzioni Speciali': inputNotes ? (inputNotes.value.trim() || '-') : '-',
            'Controllo di Stampa': serviceName,
            'DTF Metri Fatturati': billedM.toFixed(2) + " m"
          };

          const payloadItems = [
            { id: String(variantId), quantity: L, properties: propsBase },
            { id: String(serviceId), quantity: 1, properties: { "Servizio per": (inputName ? inputName.value.trim() : '') } }
          ];

          await addToCart(payloadItems);
          btnTxt.textContent = "✅ Fatto! Reindirizzamento...";
          window.location.href = '/cart';

        } catch (err) {
          console.error(err);
          btnTxt.textContent = "❌ Errore, riprova";
          setTimeout(() => {
            addBtn.disabled = false;
            syncGating();
          }, 2000);
        }
      });
    }

    enhanceFields();
    syncSheetAccessibility();
    updatePrice();
    syncGating();
    setTimeout(syncSheetHeight, 200); 
  }

  initPro();
});
